import { createRoot } from "react-dom/client";
import "../src/utils/i18n";
import "./index.css";
import { Provider } from "react-redux";
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";
import store from "./globalStore/store";

const container = document.getElementById("root");
const root = createRoot(container);

const googleMapKey = process.env.REACT_APP_MAP_TOKEN;
const script = document.getElementById("google-maps-script");

if (script) {
  script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapKey}&libraries=places,drawing,marker,core,webgl`;
}


root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
